import router from 'next/router'
import useSWRMutation, { SWRMutationConfiguration } from 'swr/mutation'
import { COMMUNITY_API_PREFIX } from 'shared/api/constants/api-constants'
import { adaptFetcherToSWRMutationFn } from 'shared/api/utils/adapt-fetcher-to-swr-mutation'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import { CreateTopicInterface, TopicInterface } from 'modules/community/types/topic-interface'

interface UseCreateTopicOptions {
  config?: SWRMutationConfiguration<TopicInterface, Error>
}

export const useCreateTopic = ({ config }: UseCreateTopicOptions = {}) => {
  const { communityPath } = router.query as { communityPath: string }

  const { fetcher } = useApiWrapperWithErrorValidation<
    RequestMethodsEnum.post,
    TopicInterface,
    CreateTopicInterface
  >({
    method: RequestMethodsEnum.post,
    badRequestHandler: () => {},
  })

  return useSWRMutation(
    `${COMMUNITY_API_PREFIX}/${communityPath}/topic`,
    adaptFetcherToSWRMutationFn<TopicInterface, CreateTopicInterface>(fetcher),
    config,
  )
}
